import React from "react"
import { useTranslation } from "react-i18next"

import { ContentEditable } from "~/components/ContentEditable/ContentEditable"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"

import { TreatmentOrder } from "./components/TreatmentOrder/TreatmentOrder"
import styles from "./index.module.css"

export const Content: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.Wrapper}>
      <div className="container grid grid--col-12">
        <div className={styles.ColLeft}>
          <div className={styles.Block}>
            <ContentEditable>
              <Heading like="h1">
                <Raw html={t("conflictCommission.Content.01.Title")} />
              </Heading>
              <Raw html={t("conflictCommission.Content.01.Text")} />
            </ContentEditable>
          </div>

          <div className={styles.Block}>
            <ContentEditable>
              <Heading like="h1">
                <Raw html={t("conflictCommission.Content.02.Title")} />
              </Heading>
              <Raw html={t("conflictCommission.Content.02.Text")} />
            </ContentEditable>
          </div>
        </div>

        <div className={styles.ColRight}>
          <TreatmentOrder />
        </div>
      </div>
    </div>
  )
}
